import Main from 'layouts/main';
import Head from 'next/head';
import React from 'react';
import useTranslation from '../../hooks/useTranslation';
import Dropshipping from '../../components/dropshipping';
import { useSelector } from 'react-redux';
import Dashboard from '../../layouts/dashboard';

function Blog() {
  const { TRANSLATIONS } = useTranslation();
  const isLoggedIn = useSelector((s) => s.isLoggedIn);
  return (
    <>
      <Head>
        <title>{TRANSLATIONS.pages.dropshipping.metaTitle}</title>
        <meta
          name="description"
          content={TRANSLATIONS.pages.dropshipping.metaDescription}
          key="desc"
        />
        <meta
          property="og:title"
          content={TRANSLATIONS.pages.dropshipping.metaTitle}
          key={'title'}
        />
        <meta
          property="og:description"
          content={TRANSLATIONS.pages.dropshipping.metaDescription}
        />
        <meta property="og:type" key="og:type" content="website" />
      </Head>
      {isLoggedIn ? (
        <Dashboard>
          <Dropshipping />
        </Dashboard>
      ) : (
        <Main>
          <Dropshipping />
        </Main>
      )}
    </>
  );
}

export default Blog;
